import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Controls from './Controls';


export default function DialogSpinner(props) {
    const { open, handleClose } = props;

    return (
        <div>
            <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="lg" 
                PaperProps={{
                    style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        minHeight: '200px',
                        position: 'absolute'
                    },
                }}>
                <DialogContent>
                    <Controls.Spinner
                        width='100px !important'
                        height='100px !important'
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            display: 'block'
                        }} />
                </DialogContent>
            </Dialog>
        </div>
    );
}